import Link from 'next/link';
import {useRouter} from 'next/router';
import React from 'react';

import {
    BrowseAggregatorContent,
    BrowsePageContent,
    CertificationAggregatorApi,
    PaginatedContent,
    RelatedCertificationAggregatorCarousel,
} from '@udemy/browse-aggregator';
import {useI18n} from '@udemy/i18n';

import {useCertificationBrowseAggregatorContext} from 'src/contexts/certification-browse-page-content-context';
import {udemyApi} from 'src/lib/ud-global-fetch';

import {CARD_CAROUSEL_PAGE_SIZE} from '../../certification-aggregator';

export const RelatedCertificationAggregatorCarouselWrapper = (props: {
    initialData: PaginatedContent<BrowsePageContent>;
}) => {
    const {initialData} = props;
    const {gettext, interpolate} = useI18n();
    const certificationAggregatorContext = useCertificationBrowseAggregatorContext();
    const certificationAggregatorApi = new CertificationAggregatorApi(udemyApi);
    const router = useRouter();

    const title = interpolate(
        certificationAggregatorContext?.isIssuerAggregator
            ? gettext('Browse %(certificationAggregatorName)s by Skill')
            : gettext('Browse %(certificationAggregatorName)s by Issuer'),
        {
            certificationAggregatorName: certificationAggregatorContext?.aggregatorContent?.title,
        },
        true,
    );

    const subtitle = gettext(
        'Get Certified for in-demand skills through our catalog of certification preparation courses',
    );

    /**
     * Note: key is added to force re-render the component when the route changes. It's necessary to update the content
     * when you're using <Link/> from next.js to navigate to the same page.
     *
     * Note: Using Link will enable prefetching + much faster page navigation
     */
    return (
        <RelatedCertificationAggregatorCarousel
            key={`${router.asPath}-related-content-carousel`}
            title={title}
            subtitle={subtitle}
            browseAggregatorContent={
                certificationAggregatorContext?.aggregatorContent as BrowseAggregatorContent
            }
            certificationAggregatorApi={certificationAggregatorApi}
            useStackedCards={false}
            initialData={initialData}
            pageSize={CARD_CAROUSEL_PAGE_SIZE}
            aggregatorCardProps={{
                linkComponent: (props: {href: string; children?: React.ReactNode}) => (
                    <Link {...props} legacyBehavior={false}>
                        {props.children}
                    </Link>
                ),
            }}
        />
    );
};
